import { render } from "./ProvenienzaView.vue?vue&type=template&id=ae0fc346&scoped=true"
import script from "./ProvenienzaView.vue?vue&type=script&lang=js"
export * from "./ProvenienzaView.vue?vue&type=script&lang=js"

import "./ProvenienzaView.vue?vue&type=style&index=0&id=ae0fc346&scoped=true&lang=css"

import exportComponent from "/Users/marco/Documents/visivalab/vueprojects/rembrandt-touch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae0fc346"]])

export default __exports__